import { Injectable } from "@angular/core";
import { OrdertypeViewModel } from "../../shared/models";
import { Observable } from "rxjs";
import { WebshopOrdertypesService } from "../../services/webShopOrdertypes.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLogService } from "../../services/log.service";

@Injectable()
export class MenuServiceSelectorService {

  constructor(
    private _webshopOrdertypesService: WebshopOrdertypesService,
    private _webShopService: WebShopService,
    private _coreLogService: CoreLogService,
    ) {
  }

  public get getSupportServices$(): Observable<OrdertypeViewModel[]> {
    return this._webshopOrdertypesService.supportedOrdertypes$;
  }

  public getIsVoucherChargeEnabled(): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      me._webShopService.getWebshopSettingsDataModel()
        .then((webshopSettingsDataModel) => {
          resolve(webshopSettingsDataModel.is_vouchercharge_enabled);
        })
        .catch(e => {
          reject();
          me._coreLogService.error("MenuServiceSelectorService.isVoucherChargeEnabled", "_webShopService.getWebshopSettingsDataModel", e);
        });
    });
  }
}
